@if (!isLoading()) {
  <app-collapsible-popup-shell
    (window:resize)="onResize($event)"
    [title]="titulo"
    [statusText]="showStatusChip() ? properties.status : null"
    [statusVariant]="
      properties.status === 'Conectado'
        ? 'active'
        : properties.status === 'Sin conexión'
          ? 'warning'
          : 'inactive'
    "
    [expanded]="isExpanded()"
    (expandedChange)="onShellToggled($event)"
    (close)="popup.closePopup()">
    <div class="badge" style="margin-bottom: 5px">
      @if (showBadge()) {
        <!-- Badge para pozos -->
        @if (pozoBadgeItem()) {
          <span>{{ pozoBadgeItem()?.proveedor }}</span>
          <span>{{ pozoBadgeItem()?.propietario }}</span>
          <span>{{ pozoBadgeItem()?.expediente }}</span>
          <span>{{ pozoBadgeItem()?.volumen }}</span>
          <span>{{ pozoBadgeItem()?.categoria }}</span>
          <span>{{ pozoBadgeItem()?.idChj }}</span>
        }
        <!-- Badge para parcelas con múltiples items -->
        @else if (parcelaBadgeItems().length > 0) {
          @for (item of parcelaBadgeItems(); track $index) {
            @if ($index > 0) {
              <hr class="separator no-margin" />
            }
            <span>{{ item.partner }}</span>
            <span>{{ item.location }}</span>
            <span>{{ item.refCatastral }}</span>
          }
        } @else if (energyBadgeLines().length > 0) {
          @for (line of energyBadgeLines(); track line) {
            <span>{{ line }}</span>
          }
        } @else if (badgeText()) {
          <span>{{ badgeText() }}</span>
        }
      }
      @if (!hideSectorBadge()) {
        <span>Sector {{ sectorLabel() }}</span>
      }
    </div>

    <!-- Contador asociado (para tomas) -->
    @if (showBadge() && counterInfo()) {
      <hr class="separator" />
      <header>
        <div class="header-text">
          <span class="title">{{ counterInfo()?.title }}</span>
        </div>
      </header>
      <div class="badge">
        <span>{{ counterInfo()?.badge }}</span>
      </div>
    }

    <!-- Info section -->
    <div class="info">
      @for (item of infoItems(); track item.label) {
        <div
          class="info-item-popup"
          [class.clickable]="item.isClickable"
          (click)="item.isClickable ? onInfoItemClick(item) : null"
          [attr.role]="item.isClickable ? 'button' : null"
          [attr.tabindex]="item.isClickable ? 0 : null">
          <span
            class="material-symbols-rounded"
            appNoTranslateMaterialSymbols
            >{{ item.icon }}</span
          >
          @if (item.isClickable) {
            <strong>{{ item.label }}</strong>
          } @else {
            <span class="info-item-popup__body">
              <span class="info-item-popup__primary">
                <span class="info-item-popup__label">{{ item.label }}:</span>
                @if (item.value !== null && item.value !== undefined) {
                  <span class="info-item-popup__value">{{
                    formatValue(item)
                  }}</span>
                } @else {
                  -
                }
              </span>
              @if (item.date) {
                <span class="popup-last-date">{{ item.date }}</span>
              }
              @if (item.secondaryText) {
                <span class="popup-last-date info-item-popup__secondary">{{
                  item.secondaryText
                }}</span>
              }
            </span>
          }
        </div>
      }

      <!-- Lista de dotaciones asignadas (para tomas) -->
      @if (waterSuppliesList().length > 0) {
        <div class="info-item-popup">
          <span class="material-symbols-rounded" appNoTranslateMaterialSymbols
            >humidity_high</span
          >
          Dotación asignada:
          <div class="listado">
            @for (supply of waterSuppliesList(); track $index) {
              <span
                >{{ supply.value }}
                <span class="popup-last-date">{{
                  supply.dateRange
                }}</span></span
              ><br />
            }
          </div>
        </div>
      }
    </div>

    <!-- Actions -->
    <div class="actions">
      @if (primaryAction()) {
        <app-button-primary
          [appLicensed]="redirectPrimaryButtonToURL()"
          width="190px"
          height="30px"
          class="popup-button"
          [label]="label_primary"
          (clicked)="onPrimaryClick()"></app-button-primary>
      }
      @if (
        secondaryAction() &&
        (!requiresOdooPermissionForSecondary() || hasViewOdooDetailsPermission)
      ) {
        <app-button-secondary
          [appLicensed]="redirectSecondaryButtonToURL()"
          width="190px"
          height="30px"
          class="popup-button"
          (clicked)="onSecondaryClick()"
          [label]="label_secondary"></app-button-secondary>
      }
    </div>
  </app-collapsible-popup-shell>
} @else {
  <div class="loading">
    <app-load-spinner></app-load-spinner>
  </div>
}
